module.exports = __webpack_public_path__ + "img/4-colorful.98f5b121.png";